/**
 * Logger utility to handle console logging based on environment
 */

const isDevelopment = process.env.NODE_ENV === 'development'
const isProduction = process.env.NODE_ENV === 'production'

// Disable all development logs
export const devLog = (...args: any[]) => {
  // Development logs disabled
}

export const devWarn = (...args: any[]) => {
  // Development logs disabled
}

export const devError = (...args: any[]) => {
  // Development logs disabled
}

export const devDebug = (...args: any[]) => {
  // Development logs disabled
}

// Only log in production
export const prodLog = (...args: any[]) => {
  if (isProduction) {
    console.log(...args)
  }
}

export const prodWarn = (...args: any[]) => {
  if (isProduction) {
    console.warn(...args)
  }
}

export const prodError = (...args: any[]) => {
  if (isProduction) {
    console.error(...args)
  }
}

export const prodDebug = (...args: any[]) => {
  if (isProduction) {
    console.debug(...args)
  }
}

// Log in both environments
export const log = (...args: any[]) => {
  if (isProduction) {
    console.log(...args)
  }
}

export const warn = (...args: any[]) => {
  if (isProduction) {
    console.warn(...args)
  }
}

export const error = (...args: any[]) => {
  if (isProduction) {
    console.error(...args)
  }
}

export const debug = (...args: any[]) => {
  if (isProduction) {
    console.debug(...args)
  }
} 